export const baseCardStyles = {
  position: "relative",
  bgcolor: "background.default",
  boxShadow: "none",
  borderRadius: "20px",
  overflow: "visible",
};

export const getFeatureCardStyles = (isLargeScreen: boolean) => ({
  minWidth: {
    xs: "auto",
    lg: isLargeScreen ? 780 : "auto",
    xl: 940,
  },
  minHeight: { lg: isLargeScreen ? 600 : "auto", xl: 680 },
  paddingTop: { xs: 3, md: 5 },
  paddingLeft: { xs: 3, md: 5 },
  paddingRight: { xs: 3, md: 5, lg: 3 },
  paddingBottom: { xs: 1.5, md: 0 },
});

export const imageContainerStyles = {
  width: "auto",
  height: { xs: 234, md: 360, lg: 400, xl: 500 },
  overflow: "hidden",
  boxSizing: "border-box",
  borderRadius: "20px",
};
